import React from "react"
import InputRadioButton from "../../../components/atoms/InputRadioButton.atom"
import { splitQuestionTextOptionalLabel } from "../../../utils/survey.utils"

export default function RadioQuestion({
  question,
  value,
  updateAnswer,
  error,
  onClearError,
}) {
  const [questionText, optionalLabel] = splitQuestionTextOptionalLabel(
    question.questionText
  )

  const handleChange = (optionValue) => {
    updateAnswer(question.questionId, "value", optionValue)

    if (error && onClearError) {
      onClearError()
    }
  }

  return (
    <div className="w-full">
      <div className="survey-question-header">
        <p>
          <span className="survey-question-text font-mulish">
            {questionText}
          </span>
          {optionalLabel && (
            <span className="font-mulish survey-optional-text">
              {` ${optionalLabel}`}
            </span>
          )}
          {error && (
            <span className="font-mulish survey-error-text"> {error}</span>
          )}
        </p>
      </div>

      {/* Desktop */}
      <div className="survey-radio-desktop">
        <div className="survey-radio-container radio-question-content">
          <div className="survey-radio-label-left">{question.leftLabel}</div>

          <div className="survey-radio-options">
            {question.options.map((option) => (
              <div
                key={option.optionId}
                className="survey-radio-option font-mulish"
              >
                <div className="survey-radio-option-label font-mulish">
                  {option.optionLabel}
                </div>

                <div className="survey-radio-option-control">
                  <InputRadioButton
                    name={`question-${question.questionId}`}
                    value={option.optionValue}
                    checked={value?.value === option.optionValue}
                    onChange={() => handleChange(option.optionValue)}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="survey-radio-label-right">{question.rightLabel}</div>
        </div>
      </div>

      {/* Mobile */}
      <div className="survey-radio-mobile">
        <div
          className="survey-radio-grid"
          style={{
            gridTemplateColumns: `repeat(${question.options.length}, 1fr)`,
          }}
        >
          {question.options.map((option) => (
            <div key={option.optionId} className="survey-radio-mobile-option">
              <div className="survey-radio-mobile-label">
                {option.optionLabel}
              </div>

              <InputRadioButton
                name={`question-${question.questionId}`}
                value={option.optionValue}
                checked={value?.value === option.optionValue}
                onChange={() => handleChange(option.optionValue)}
              />
            </div>
          ))}
        </div>

        <div className="survey-radio-mobile-edges">
          <span className="survey-radio-mobile-left">{question.leftLabel}</span>

          <span className="survey-radio-mobile-right">
            {question.rightLabel}
          </span>
        </div>
      </div>
    </div>
  )
}
